import { render } from "./DiscountBadge.vue?vue&type=template&id=224fe22b&lang=pug"
import script from "./DiscountBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./DiscountBadge.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__